import React from "react";
import TextField from "@mui/material/TextField";
import { getName } from "../../helper";

const Input = ({ item }) => {
  return (
    <TextField
      fullWidth
      autoComplete="off"
      helperText={item.properties?.help}
      disabled={item.properties?.disabled}
      label={getName(item, "Input")}
      placeholder={item.properties?.value}
    />
  );
};

export default Input;
